package com.bikompanion.data

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

/**
 * OSM tag values are strings, all of them — `capacity=6` comes back as `"6"`, not `6`. Typing
 * these as anything else fails the whole response rather than the one tag.
 */
@Serializable
internal data class OverpassTags(
    val capacity: String? = null,
    val covered: String? = null,
    @SerialName("bicycle_parking") val bicycleParking: String? = null,
    @SerialName("addr:street") val street: String? = null,
    @SerialName("addr:housenumber") val houseNumber: String? = null,
    @SerialName("addr:city") val city: String? = null,
)
